/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/l-lin/angular-datatables/master/LICENSE
 */
import { Directive, ElementRef, Input } from '@angular/core';
var DataTableDirective = (function () {
    function DataTableDirective(el) {
        this.el = el;
        /**
         * The DataTable option you pass to configure your table.
         */
        this.dtOptions = {};
    }
    DataTableDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.dtTrigger) {
            this.dtTrigger.subscribe(function () {
                _this.displayTable();
            });
        }
        else {
            this.displayTable();
        }
    };
    DataTableDirective.prototype.ngOnDestroy = function () {
        if (this.dtTrigger) {
            this.dtTrigger.unsubscribe();
        }
        if (this.dt) {
            this.dt.destroy(true);
        }
    };
    DataTableDirective.prototype.displayTable = function () {
        var _this = this;
        this.dtInstance = new Promise(function (resolve, reject) {
            Promise.resolve(_this.dtOptions).then(function (dtOptions) {
                // Using setTimeout as a "hack" to be "part" of NgZone
                setTimeout(function () {
                    _this.dt = $(_this.el.nativeElement).DataTable(dtOptions);
                    resolve(_this.dt);
                });
            });
        });
    };
    return DataTableDirective;
}());
export { DataTableDirective };
DataTableDirective.decorators = [
    { type: Directive, args: [{
                selector: '[datatable]'
            },] },
];
/** @nocollapse */
DataTableDirective.ctorParameters = function () { return [
    { type: ElementRef, },
]; };
DataTableDirective.propDecorators = {
    'dtOptions': [{ type: Input },],
    'dtTrigger': [{ type: Input },],
};
//# sourceMappingURL=angular-datatables.directive.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/node_modules/angular-datatables/src/angular-datatables.directive.js
// module id = ../../../../angular-datatables/src/angular-datatables.directive.js
// module chunks = vendor